<template>
  <div class="mc-auth-profile">
    <h1 class="text-align-center">个人中心页面</h1>
  </div>
</template>

<script>
// import variables from '@/assets/css/variables.scss'

import { getPassport } from "@/libs/passport";
import { getProfile } from '@/api/user'

export default {
  data() {
    return {
    }
  },
  computed: {
    variables() {
      return true
    }
  },
  mounted() {
    getPassport().then((res) => {
      if (res) {
        console.log('成功！')
        this.getProfile()
      } else {
        console.log('失败！')
      }
    })
  },
  methods: {
    getProfile(){
      getProfile().then(res => {
        const { data } = res
        const user = data.user
        console.log(user)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mc-auth-profile {
  .text-align-center {
    text-align: center;
  }
  .box-container {
    padding: 16px;
  }
}
</style>
